import React from 'react';
import { Helmet } from "react-helmet-async";

import Header from './Header.js';
import Hero from './Hero.js';
import About from './About.js';
import Services from './Services.js';
import Contact from './Contact.js';
import Footer from './Footer.js';

const Home = () => {
  return (
    <>
      <Helmet>
        <title>VNM Hitech Solutions | Software Development Company in Karur</title>

        <meta
          name="description"
          content="VNM Hitech Solutions is a software development company in Karur, Tamil Nadu offering web development, mobile app development, IT services, and software training."
        />

        <meta
          name="keywords"
          content="software development company in Karur, IT company in Karur, web development company in Karur, software company in Karur Tamil Nadu, website development company in Karur, mobile app development company in Karur, software training institute in Karur, full stack developer course Karur, react js training Karur, IT services company in Karur"
        />
      </Helmet>

      <Header />
      <main>
        <Hero />
        <Services />
        <About />
        <Contact />
      </main>
      <Footer />
    </>
  );
};

export default Home;